import React, { useContext, useEffect, useState } from 'react';
import { getAuthorizedPersonsProfile, getLanguagesType, getClasses } from '../../../actions';
import { Context } from '../../../defaults';
import { Table } from 'antd';

const SchoolStudents = () => {
    const { dictionary, language } = useContext(Context);

    const [students, setStudents] = useState();
    const [languages, setLanguages] = useState();
    const [classes, setClasses] = useState();


    useEffect(() => {
        getAuthorizedPersonsProfile().then(({ data }) => setStudents(data.institution.students));
        getLanguagesType().then(({ data }) => setLanguages(data));
        getClasses().then(({ data }) => setClasses(data));
    }, []);


    const columns = [
        {
            title: dictionary?.LastName[language],
            dataIndex: 'lastName',
            key: 'lastName',
            fixed: 'left'
        },
        {
            title: dictionary?.FirstName[language],
            dataIndex: 'firstName',
            key: 'firstName',
            fixed: 'left'
        },
        {
            title: dictionary?.MiddleName[language],
            dataIndex: 'middleName',
            key: 'middleName',
            fixed: 'left'
        },

        {
            title: dictionary?.Phone[language],
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: dictionary?.StudyYear[language],
            dataIndex: 'studyYear',
            key: 'StudyYear',
        },
        {
            title: dictionary?.Language[language],
            dataIndex: 'langId',
            key: 'langId',
            render: (langId) => !!langId ? languages && languages.find((el) => el.id === langId).name : ''

        },
        {
            title: dictionary?.Country[language],
            dataIndex: 'country',
            key: 'country',
        },
        {
            title: dictionary?.Region[language],
            dataIndex: 'region',
            key: 'region',
        },
        {
            title: dictionary?.Class[language],
            dataIndex: 'classId',
            key: 'classId',
            render: (classId) => !!classId ? classes && classes.find((el) => el.id === classId).year + '' + classes && classes.find((el) => el.id === classId).letter : ''
        },
    ];


    return (
        <React.Fragment>
            <Table columns={columns} dataSource={students} rowKey="students" scroll={{ x: 1300 }} />
        </React.Fragment>
    );
};
export default SchoolStudents;